import React from "react"

import FieldExpenseApprovalStatus_PopoverOption from "../option/option"

type Props = {
    className?  : string

    options     : any[]

    onClick     : func
    onDelete    : func

    children?    : any
}

// const debug = "FieldExpenseApprovalStatus_MultiValueNotEmpty"
const debug = false

export default function FieldExpenseApprovalStatus_MultiValueNotEmpty(props: Props) {

    debug && console.log(debug, "render", props)

    return (
        <>
            <div className={Classes("ui5-field-form-editable dropdown-form fl-wrap min-h-36", props.className)} onClick={props.onClick}>
                {_.map(props.options, option => <FieldExpenseApprovalStatus_PopoverOption key={option.value} className="m-r-10 m-t-4 m-b-4" option={option} onDelete={props.onDelete}/>)}
            </div>
            {props.children}
        </>
    )
}